import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable, take } from 'rxjs';

import { EMPTY_STATUS_CASCADE, StatusCascade } from '@efficiently/models';

import { ApprovalsRepository, SetApprovalStatusArgs } from '@efficiently/client-api-approvals';

import { SET_APPROVAL_STATUS, SET_APPROVAL_STATUS_WITH_CASCADE } from '../graphql/queries';

@Injectable()
export class ApprovalsGqlRepository extends ApprovalsRepository {
	private readonly apollo = inject(Apollo);

	public override setApprovalStatus(args: SetApprovalStatusArgs[]): Observable<boolean> {
		return this.apollo
			.mutate({
				mutation: SET_APPROVAL_STATUS,
				variables: { args },
			})
			.pipe(
				map(({ data }) => data?.setApprovalStatus ?? false),
				take(1),
			);
	}

	public override setStatusWithCascade(args: SetApprovalStatusArgs[]): Observable<StatusCascade> {
		return this.apollo
			.mutate({
				mutation: SET_APPROVAL_STATUS_WITH_CASCADE,
				variables: { args },
			})
			.pipe(
				// TEMP-CODEGEN-FRONTIER(EFF-24658): result is the app-wide `StatusCascade` domain shape.
				map(({ data }) => (data?.setApprovalStatusWithCascade as unknown as StatusCascade) ?? EMPTY_STATUS_CASCADE),
				take(1),
			);
	}
}
